import { render } from "./TeamsOverview.vue?vue&type=template&id=710e90e6"
import script from "./TeamsOverview.vue?vue&type=script&lang=js"
export * from "./TeamsOverview.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__